import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { patchNoteTov } from "@/lib/dictation";
import { INK, SUB, MUTE, HAIR } from "./erShared";

// Plain text at rest, ghost pulldown on row hover/focus; menu rendered in a fixed portal.
export function TovCell({ note, tovList, onApply }) {
  const [pos, setPos] = useState(null);
  const [saving, setSaving] = useState(false);
  const btn = useRef(null);
  const menu = useRef(null);
  const cur = note.tov && note.tov !== "NOT SET" ? note.tov : null;
  const open = !!pos;

  useEffect(() => {
    if (!open) return;
    const close = () => setPos(null);
    const onDoc = (e) => { if (!menu.current?.contains(e.target) && !btn.current?.contains(e.target)) close(); };
    const onKey = (e) => { if (e.key === "Escape") close(); };
    const onScroll = (e) => { if (!menu.current?.contains(e.target)) close(); };
    document.addEventListener("mousedown", onDoc); document.addEventListener("keydown", onKey);
    window.addEventListener("scroll", onScroll, true); window.addEventListener("resize", close);
    return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); window.removeEventListener("scroll", onScroll, true); window.removeEventListener("resize", close); };
  }, [open]);

  const toggle = () => {
    if (open) return setPos(null);
    const r = btn.current.getBoundingClientRect();
    setPos({ left: r.left, top: r.bottom + 4 });
  };
  const choose = async (val) => {
    setPos(null);
    if ((note.tov || "NOT SET") === val) return;
    const prev = note.tov;
    setSaving(true);
    onApply(note.id, val);
    try { await patchNoteTov(note.id, val); toast.success(`Visit type set to ${val === "NOT SET" ? "Not set" : val}`); }
    catch (e) { onApply(note.id, prev); toast.error(e?.message || "Could not set the visit type."); }
    finally { setSaving(false); }
  };
  const Opt = ({ val, label, on }) => (
    <button type="button" onClick={() => choose(val)} className="w-full flex items-center text-left rounded-[7px] hover:bg-[#F1F1F4]" style={{ fontSize: 13, padding: "8px 10px", color: INK }} data-testid={`er-tov-opt-${note.id}-${val === "NOT SET" ? "notset" : val}`}>
      <span style={{ width: 18, flex: "none" }}>{on ? <Check size={13} /> : null}</span><span className="truncate">{label}</span>
    </button>
  );

  return (
    <span onClick={(e) => e.stopPropagation()}>
      <button ref={btn} type="button" data-open={open ? "true" : "false"} onClick={toggle} className="er-tovcell" style={{ color: cur ? INK : MUTE, opacity: saving ? 0.5 : 1 }} data-testid={`er-row-tov-${note.id}`} title="Set visit type">
        <span className="truncate">{cur || "Not set"}</span>
        <svg className="er-tovchev" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
      </button>
      {open ? createPortal(
        <div ref={menu} onClick={(e) => e.stopPropagation()} style={{ position: "fixed", left: pos.left, top: pos.top, zIndex: 9800, minWidth: 210, maxHeight: 300, overflowY: "auto", background: "#fff", border: `1px solid ${HAIR}`, borderRadius: 12, boxShadow: "0 10px 28px rgba(20,20,18,.14)", padding: 6 }} data-testid={`er-tov-menu-${note.id}`}>
          {tovList.map((t) => <Opt key={t} val={t} label={t} on={cur === t} />)}
          <div style={{ height: 1, background: HAIR, margin: "6px 4px" }} />
          <Opt val="NOT SET" label={<span style={{ color: cur ? SUB : INK }}>Not set</span>} on={!cur} />
        </div>, document.body) : null}
    </span>
  );
}
